import { useEffect, useState } from 'react'

import api from '../../api/api'

import { getIdFromObjectOrValue } from './components/helpers'

export const useFetchSocialLinks = (building) => {
  const [socialLinks, setSocialLinks] = useState([])

  const fetchSocialLinks = async () => {
    if (!building) {
      return
    }

    try {
      const resp = await api.fetchSocialLinks(getIdFromObjectOrValue(building))
      const modifiedLinks = resp.data.map((link) => ({
        value: link.id,
        label: link.link,
        ...link,
      }))
      setSocialLinks(modifiedLinks)
    } catch (error) {
      console.error(error)
    }
  }

  // Note: Fetch social links and refetch on every window focus change
  useEffect(() => {
    fetchSocialLinks()

    window.addEventListener('focus', fetchSocialLinks)

    return () => {
      window.removeEventListener('focus', fetchSocialLinks)
    }
  }, [building])

  return socialLinks
}
